export function faq(client) {
    return {
        fetchList: function () {
            return client.get('/faq');
        }
    };
}